(function () {
  /** Saved-address CRUD (max 3, server-enforced) — governorate/area cascading picker. */

  var STR = (window.ErosAccountStrings && window.ErosAccountStrings.addresses) || {};
  function t(key, fallback) {
    return STR[key] || fallback;
  }
  var LOCALE = (document.documentElement.getAttribute('lang') || 'ar').split('-')[0];

  var MAX_ADDRESSES = 3;

  // GET /v1/customer/addresses returns raw Shopify MailingAddress fields
  // (address1/address2/city/province/zip/phone), not the governorateId/areaId
  // sent on write — the worker encodes those into zip as "{governorateId}-{areaId}"
  // on create/update. Decode it back for the edit form's dropdowns.
  /**
   * The Waseet `governorate-area` code. It lives in `company`; it used to be
   * in `zip`, but Iraq has no postal-code format matching `5-5433` and
   * Shopify rejected every saved address (owner 2026-09-09). Shopify has no
   * metafields on an address, so `company` — unused by Eros otherwise —
   * holds it. Reads still fall back to `zip` for rows saved before the move.
   */
  function waseetCodeOf(addr) {
    if (!addr) return '';
    return (addr.company || addr.zip || '').trim();
  }

  function decodeZip(zip) {
    if (!zip) return null;
    var parts = String(zip).split('-');
    if (parts.length !== 2) return null;
    return { governorateId: parts[0], areaId: parts[1] };
  }

  /** Mirrors AccountOrganicHeader.formatIraqLocalPhone (eros-account-shell.js). */
  function formatIraqLocalPhone(raw) {
    if (raw == null) return '';
    var s = String(raw).trim();
    if (!s) return '';
    if (s.indexOf('+964') === 0) return '0' + s.slice(4);
    if (s.indexOf('964') === 0 && s.length > 3) return '0' + s.slice(3);
    var digits = s.replace(/[^0-9٠-٩]/g, '');
    var map = { '٠': '0', '١': '1', '٢': '2', '٣': '3', '٤': '4', '٥': '5', '٦': '6', '٧': '7', '٨': '8', '٩': '9' };
    digits = digits.replace(/[٠-٩]/g, function (d) { return map[d]; });
    if (digits.length === 10 && digits.charAt(0) === '7') return '0' + digits;
    if (digits.length === 11 && digits.charAt(0) === '0') return digits;
    return s;
  }

  function prefillPhoneIfEmpty(phoneInput) {
    if (phoneInput.value.trim()) return;

    var session = window.ErosSession ? window.ErosSession.get() : null;
    if (session && session.e164) {
      phoneInput.value = formatIraqLocalPhone(session.e164);
      return;
    }

    if (window.ErosCommerce && window.ErosCommerce.getProfile) {
      window.ErosCommerce.getProfile()
        .then(function (res) {
          if (!phoneInput.value.trim() && res.profile && res.profile.phone) {
            phoneInput.value = formatIraqLocalPhone(res.profile.phone);
          }
        })
        .catch(function () {});
    }
  }

  function render(container) {
    container.innerHTML = '';
    var loading = window.ErosUI.el('div', 'eros-account-skeleton', { 'aria-busy': 'true' });
    loading.setAttribute('aria-label', t('loading', 'جارٍ التحميل...'));
    container.appendChild(loading);

    // The catalog is loaded alongside the list so the rows can show the
    // governorate/area in the page language (ADR-178: Shopify stores the
    // canonical Arabic names; the UI locale is display-only). A catalog
    // failure degrades to the stored Arabic text, never to an empty list.
    var catalogPromise = window.ErosIraqAddressCatalog
      ? window.ErosIraqAddressCatalog.get().catch(function () { return null; })
      : Promise.resolve(null);
    Promise.all([window.ErosCommerce.listAddresses(), catalogPromise])
      .then(function (results) {
        container.innerHTML = '';
        renderList(container, results[0].addresses || [], results[1]);
      })
      .catch(function () {
        container.innerHTML = '';
        var err = window.ErosUI.el('p', 'eros-field__error');
        err.textContent = t('load_error', 'تعذّر تحميل العناوين');
        container.appendChild(err);
      });
  }

  /**
   * Localised governorate/area for a saved address — mirrors
   * ErosDeliveryAddressCodec.displayLines (Flutter): decode the Waseet code
   * and render the catalog label for LOCALE; fall back to the stored text
   * (canonical Arabic since ADR-178) when the code or catalog is missing.
   */
  function placeLabels(addr, catalog) {
    var decoded = decodeZip(waseetCodeOf(addr));
    var gov = decoded && catalog
      ? window.ErosIraqAddressCatalog.governorateById(catalog, decoded.governorateId)
      : null;
    var area = gov ? window.ErosIraqAddressCatalog.areaById(gov, decoded.areaId) : null;
    return {
      governorate: gov
        ? window.ErosIraqAddressCatalog.governorateNameForLocale(gov, LOCALE)
        : (addr.city || ''),
      area: area
        ? window.ErosIraqAddressCatalog.areaLabelForLocale(area, LOCALE)
        : (addr.address1 || ''),
      // ADR-183: no code, or a code the catalog no longer has — the address
      // cannot confirm an order until the area is picked again. Same rule as
      // the app's «يحتاج تحديث» badge (needsAreaUpdate).
      needsUpdate: !(gov && area),
    };
  }

  function renderList(container, addresses, catalog) {
    if (!addresses.length) {
      var emptyWrap = window.ErosUI.el('div', 'eros-address-empty');
      var empty = window.ErosUI.el('p');
      empty.textContent = t('empty', 'لا يوجد عنوان محفوظ بعد');
      emptyWrap.appendChild(empty);
      container.appendChild(emptyWrap);
    } else {
      // Flutter AccountAddressesList — flat ListTile panel, not bordered cards.
      var panel = window.ErosUI.el('div', 'eros-address-panel');
      addresses.forEach(function (addr, i) {
        if (i > 0) panel.appendChild(window.ErosUI.el('div', 'eros-address-divider'));
        panel.appendChild(buildAddressRow(addr, container, catalog));
      });
      container.appendChild(panel);
    }

    if (addresses.length < MAX_ADDRESSES) {
      var addBtn = window.ErosUI.el('button', 'button button--secondary eros-address-add', { type: 'button' });
      addBtn.textContent = '+ ' + t('add_address', 'إضافة عنوان جديد');
      addBtn.addEventListener('click', function () {
        renderForm(container, null);
      });
      container.appendChild(addBtn);
    }
  }

  function buildAddressRow(addr, container, catalog) {
    var row = window.ErosUI.el('div', 'eros-address-row');
    var place = placeLabels(addr, catalog);

    var title = window.ErosUI.el('p', 'eros-address-row__title');
    var titleText = document.createElement('span');
    titleText.textContent = place.area || place.governorate || t('empty', 'عنوان');
    title.appendChild(titleText);
    if (addr.isDefault) {
      var badge = window.ErosUI.el('span', 'eros-address-row__badge');
      badge.textContent = t('default', 'الافتراضي');
      title.appendChild(badge);
    }
    if (place.needsUpdate) {
      var warn = window.ErosUI.el('span', 'eros-address-row__badge eros-address-row__badge--warn');
      warn.textContent = t('needs_update', 'يحتاج تحديث');
      title.appendChild(warn);
    }
    row.appendChild(title);

    // Governorate goes on the sub line unless it already carried the title.
    var subParts = [addr.address2, place.area ? place.governorate : '', addr.phone].filter(Boolean);
    if (subParts.length) {
      var sub = window.ErosUI.el('p', 'eros-address-row__sub');
      sub.textContent = subParts.join('\n');
      row.appendChild(sub);
    }

    var actions = window.ErosUI.el('div', 'eros-address-row__actions');

    var editBtn = window.ErosUI.el('button', 'link', { type: 'button' });
    editBtn.textContent = t('edit', 'تعديل');
    editBtn.addEventListener('click', function () {
      renderForm(container, addr);
    });
    actions.appendChild(editBtn);

    if (!addr.isDefault) {
      var defaultBtn = window.ErosUI.el('button', 'link', { type: 'button' });
      defaultBtn.textContent = t('set_default', 'اجعله الافتراضي');
      defaultBtn.addEventListener('click', function () {
        window.ErosCommerce
          .setDefaultAddress(addr.id)
          .then(function () {
            render(container);
          })
          .catch(function () {
            window.ErosUI.toast(t('generic_error', 'حدث خطأ، حاول مرة أخرى'), 'error');
          });
      });
      actions.appendChild(defaultBtn);
    }

    var deleteBtn = window.ErosUI.el('button', 'link', { type: 'button' });
    deleteBtn.textContent = t('delete', 'حذف');
    deleteBtn.addEventListener('click', function () {
      if (!window.confirm(t('confirm_delete', 'حذف هذا العنوان؟'))) return;
      window.ErosCommerce
        .deleteAddress(addr.id)
        .then(function () {
          render(container);
        })
        .catch(function () {
          window.ErosUI.toast(t('generic_error', 'حدث خطأ، حاول مرة أخرى'), 'error');
        });
    });
    actions.appendChild(deleteBtn);

    row.appendChild(actions);
    return row;
  }

  /**
   * Opens the same address form used by the account page inside a sheet, for
   * checkout's "Edit address" button — matches checkout_saved_address_editor.dart
   * reusing AccountErosAddressFormDialog rather than a separate checkout-only form.
   */
  function openEditDialog(existing, title, onSaved) {
    var host = window.ErosUI.el('div');
    var sheet = window.ErosUI.openSheet({ title: title, content: host });
    renderForm(host, existing, function () {
      sheet.close();
      if (onSaved) onSaved();
    });
  }

  function renderForm(container, existing, onDone) {
    onDone = onDone || function () { render(container); };
    container.innerHTML = '';
    var form = window.ErosUI.el('form', 'eros-address-form');

    var phoneField = window.ErosUI.el('div', 'form-control');
    var phoneLabel = window.ErosUI.el('label');
    phoneLabel.textContent = t('phone_label', 'هاتف الاستلام');
    var phoneInput = window.ErosUI.el('input', 'input', { type: 'tel' });
    phoneInput.value = (existing && existing.phone && String(existing.phone).trim()) || '';
    if (!phoneInput.value.trim()) {
      prefillPhoneIfEmpty(phoneInput);
    }
    var phoneHint = window.ErosUI.el('p', 'eros-address-phone-hint');
    phoneHint.textContent = t('phone_hint', 'للمندوب عند التسليم — يمكن تغييره');
    phoneField.appendChild(phoneLabel);
    phoneField.appendChild(phoneInput);
    phoneField.appendChild(phoneHint);

    var govField = window.ErosUI.el('div', 'form-control');
    var govLabel = window.ErosUI.el('label');
    govLabel.textContent = t('governorate_label', 'المحافظة');
    var govSelect = window.ErosUI.el('select', 'select');
    govField.appendChild(govLabel);
    govField.appendChild(govSelect);

    var areaField = window.ErosUI.el('div', 'form-control');
    var areaLabel = window.ErosUI.el('label');
    areaLabel.textContent = t('area_label', 'المنطقة');
    // Hundreds of areas per governorate (up to ~6,100 nationwide) — a plain
    // <select> is unusable, so this is a tappable trigger that opens the
    // searchable picker sheet (eros-iraq-area-picker.js), matching
    // mobile_app's iraq_area_picker_sheet.dart exactly.
    var areaTrigger = window.ErosUI.el('button', 'input eros-area-trigger', { type: 'button' });
    areaTrigger.textContent = t('area_select_trigger', 'اختر المنطقة');
    var selectedAreaId = null;
    areaField.appendChild(areaLabel);
    areaField.appendChild(areaTrigger);

    var landmarkField = window.ErosUI.el('div', 'form-control');
    var landmarkLabel = window.ErosUI.el('label');
    landmarkLabel.textContent = t('landmark_label', 'أقرب نقطة دالة');
    var landmarkInput = window.ErosUI.el('input', 'input', { type: 'text' });
    // The worker has no dedicated "landmark" field on read — it's folded into
    // address2 on write, so that's the closest existing value to prefill from.
    landmarkInput.value = (existing && existing.address2) || '';
    landmarkField.appendChild(landmarkLabel);
    landmarkField.appendChild(landmarkInput);

    form.appendChild(phoneField);
    form.appendChild(govField);
    form.appendChild(areaField);
    form.appendChild(landmarkField);

    var submit = window.ErosUI.el('button', 'button', { type: 'submit' });
    submit.textContent = t('save', 'حفظ');
    form.appendChild(submit);

    var cancel = window.ErosUI.el('button', 'link', { type: 'button' });
    cancel.textContent = t('cancel', 'إلغاء');
    cancel.addEventListener('click', function () {
      onDone();
    });
    form.appendChild(cancel);

    container.appendChild(form);

    var decoded = existing ? decodeZip(waseetCodeOf(existing)) : null;

    var catalog;
    window.ErosIraqAddressCatalog.get().then(function (loaded) {
      catalog = loaded;
      // No pre-selected governorate or area (owner 2026-10-01): a new address
      // used to open on the first governorate + its default area (بغداد /
      // أبو غريب), so «حفظ» could save a place the customer never chose.
      var placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.disabled = true;
      placeholder.textContent = t('governorate_select_trigger', 'اختر المحافظة');
      govSelect.appendChild(placeholder);
      catalog.governorates.forEach(function (gov) {
        var o = document.createElement('option');
        o.value = gov.id;
        o.textContent = window.ErosIraqAddressCatalog.governorateNameForLocale(gov, LOCALE);
        govSelect.appendChild(o);
      });
      var initialGovId = decoded && decoded.governorateId ? decoded.governorateId : '';
      var initialAreaId = decoded ? decoded.areaId : null;
      // ADR-215 §2.2: no usable area → governorate from the city, area from the
      // address text (one match only). A prefill; nothing saves until «حفظ».
      var prefill = existing && window.ErosAddressRules ? window.ErosAddressRules.editorPrefill(catalog, existing, initialGovId, initialAreaId) : null;
      if (prefill) { initialGovId = prefill.governorateId; initialAreaId = prefill.areaId; }
      govSelect.value = initialGovId;
      setArea(initialGovId, initialAreaId);
    });

    govSelect.addEventListener('change', function () {
      // Changing governorate invalidates any previously picked area — matches
      // iraq_address_form.dart (no explicit carry-over of the old area id).
      setArea(govSelect.value, null);
    });

    function setArea(govId, areaId) {
      var gov = govId ? window.ErosIraqAddressCatalog.governorateById(catalog, govId) : null;
      selectedAreaId = areaId || '';
      var area = gov && selectedAreaId ? window.ErosIraqAddressCatalog.areaById(gov, selectedAreaId) : null;
      // ADR-183: a stored id the catalog no longer has is not kept behind the
      // placeholder — it used to be re-saved untouched. The picker must be used.
      if (!area) selectedAreaId = '';
      else selectedAreaId = area.id;
      areaTrigger.textContent = area
        ? window.ErosIraqAddressCatalog.areaLabelForLocale(area, LOCALE)
        : t('area_select_trigger', 'اختر المنطقة');
    }

    areaTrigger.addEventListener('click', function () {
      var gov = window.ErosIraqAddressCatalog.governorateById(catalog, govSelect.value);
      if (!gov) return;
      window.ErosIraqAreaPicker.open(gov, LOCALE, selectedAreaId, function (area) {
        selectedAreaId = area.id;
        areaTrigger.textContent = window.ErosIraqAddressCatalog.areaLabelForLocale(area, LOCALE);
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var phone = phoneInput.value.trim();
      if (!phone) {
        window.ErosUI.setFieldError(phoneInput, t('required', 'مطلوب'));
        return;
      }
      window.ErosUI.setFieldError(phoneInput, null);

      // The detailed line is required, same as the app (owner rule
      // 2026-09-09): an area alone does not get a courier to the door.
      var landmarkValue = landmarkInput.value.trim();
      if (!landmarkValue) {
        window.ErosUI.setFieldError(landmarkInput, t('required', 'مطلوب'));
        return;
      }
      window.ErosUI.setFieldError(landmarkInput, null);

      var gov = govSelect.value ? window.ErosIraqAddressCatalog.governorateById(catalog, govSelect.value) : null;
      if (!gov) {
        window.ErosUI.setFieldError(govSelect, t('governorate_select_trigger', 'اختر المحافظة'));
        return;
      }
      window.ErosUI.setFieldError(govSelect, null);
      var area = window.ErosIraqAddressCatalog.areaById(gov, selectedAreaId);
      // ADR-183: the area must exist in the catalog — the worker refuses
      // anything else (area_id_unknown) and the checkout would refuse the row.
      if (!area) {
        window.ErosUI.setFieldError(areaTrigger, t('area_unknown', 'اختر المنطقة من القائمة'));
        return;
      }
      window.ErosUI.setFieldError(areaTrigger, null);

      var payload = {
        phone: phone,
        governorateId: govSelect.value,
        governorateNameAr: gov ? gov.nameAr : undefined,
        areaId: selectedAreaId,
        areaLabelAr: area ? area.labelAr : undefined,
        landmark: landmarkValue,
      };

      submit.disabled = true;
      var op = existing ? window.ErosCommerce.updateAddress(existing.id, payload) : window.ErosCommerce.createAddress(payload);
      op
        .then(function () {
          onDone();
        })
        .catch(function (err) {
          if (err.code === 'address_limit_reached') {
            window.ErosUI.toast(t('limit_reached', 'وصلت للحد الأقصى (3 عناوين)'), 'error');
          } else if (err.code === 'area_id_unknown') {
            window.ErosUI.setFieldError(areaTrigger, t('area_unknown', 'اختر المنطقة من القائمة'));
          } else {
            window.ErosUI.toast(t('generic_error', 'حدث خطأ، حاول مرة أخرى'), 'error');
          }
        })
        .finally(function () {
          submit.disabled = false;
        });
    });
  }

  window.ErosAccountAddresses = { render: render, openEditDialog: openEditDialog };
})();
